"use client";

import { BlockRenderer } from "@/components/block-renderer";
import { cn } from "@/lib/utils";
import { type BlocksContent } from "@strapi/blocks-react-renderer";
import { useTranslations } from "next-intl";
import { useState } from "react";

type ListingSpecialHeaderDescriptionProps = {
  content: BlocksContent;
};

export const ListingSpecialHeaderDescription = ({
  content,
}: ListingSpecialHeaderDescriptionProps) => {
  const [expanded, setExpanded] = useState(false);
  const [lineClamp, setLineClamp] = useState(true);
  const t = useTranslations("caterings");

  const handleExpand = () => {
    setExpanded(!expanded);
    lineClamp
      ? setLineClamp(false)
      : setTimeout(() => {
          setLineClamp(true);
        }, 500);
  };

  return (
    <>
      <div
        className={cn(
          "relative overflow-hidden transition-[max-height] duration-500",
          !expanded && "max-h-12",
          expanded && "max-h-[300rem]",
          lineClamp && "line-clamp-2"
        )}
      >
        <div className={cn(!lineClamp && "prose", "leading-6")}>
          <BlockRenderer content={content} />
        </div>
        {!expanded && (
          <span
            className="absolute bottom-[0.1rem] right-12 md:right-0 cursor-pointer bg-brand-white  hover:no-underline"
            onClick={handleExpand}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") handleExpand();
            }}
            role="button"
            tabIndex={0}
          >
            <span>...</span>{" "}
            <span className="underline underline-offset-4">
            {t("show_more")}
            </span>
          </span>
        )}
      </div>
      {expanded && (
        <p
          className="mt-2 cursor-pointer underline underline-offset-4 hover:no-underline"
          onClick={handleExpand}
        >
          {t("show_less")}
        </p>
      )}
    </>
  );
};
